var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSparrowTool = function SvgSparrowTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    className: "annotation-path",
    d: "M18 5c7.732 0 14 4.477 14 10s-6.268 10-14 10c-.492 0-.977-.018-1.456-.053-.74-.055-7.8 4.421-8.544 4.17-.78-.261.907-6.502.48-6.784C5.726 20.506 4 17.897 4 15 4 9.477 10.268 5 18 5Zm0 2c-6.744 0-12 3.754-12 8 0 2.095 1.271 4.132 3.585 5.665.562.372.795.839.905 1.357.045.212.06.412.06.628 0 .267-.025.566-.072.935-.061.485-.077.584-.335 2.106l-.046.272-.01.061.193-.104.744-.409.278-.154.125-.069c1.989-1.103 2.074-1.15 2.697-1.476 1.39-.727 1.822-.915 2.567-.86.433.032.87.048 1.309.048 6.744 0 12-3.754 12-8s-5.256-8-12-8Zm-.926 2.876 8.955 1.482-6.432 6.404-.944-2.955c-.62.36-1.261.787-1.923 1.283a27.677 27.677 0 0 0-3.952 3.58l-.67.742-1.484-1.34.67-.742a29.672 29.672 0 0 1 4.236-3.84 20.864 20.864 0 0 1 2.5-1.627l-.956-2.987Z",
    fill: "#707070"
  }))));
};

export default SvgSparrowTool;